import { Box, Typography, Checkbox } from "@mui/material";

// =============================================================================
// Sheet Picker
// =============================================================================

interface SheetPickerProps {
  sheetNames: string[];
  selectedSheets: string[];
  filename: string;
  disabled: boolean;
  onSheetChange: (sheetName: string, checked: boolean) => void;
  onSelectAll: (checked: boolean) => void;
}

export const SheetPicker = ({
  sheetNames,
  selectedSheets,
  filename,
  disabled,
  onSheetChange,
  onSelectAll,
}: SheetPickerProps) => {
  const allSelected = selectedSheets.length === sheetNames.length;
  const someSelected = selectedSheets.length > 0 && !allSelected;
  const noneSelected = selectedSheets.length === 0;

  return (
    <Box sx={{ pl: 4, pt: 1 }}>
      <Typography variant="caption" color="text.secondary" sx={{ display: "block", fontWeight: 500, mb: 0.5 }}>
        Sheets to upload
      </Typography>
      <Box
        component="label"
        sx={{ display: "flex", alignItems: "center", gap: 0.5, cursor: disabled ? "default" : "pointer" }}
      >
        <Checkbox
          size="small"
          checked={allSelected}
          indeterminate={someSelected}
          onChange={(_e, checked) => onSelectAll(checked)}
          disabled={disabled}
          inputProps={{ "aria-label": `Select all sheets from ${filename}` }}
        />
        <Typography variant="body2">Select all</Typography>
      </Box>
      <Box sx={{ pl: 3, maxHeight: 180, overflowY: "auto" }}>
        {sheetNames.map((sheetName) => (
          <Box
            key={sheetName}
            component="label"
            sx={{ display: "flex", alignItems: "center", gap: 0.5, cursor: disabled ? "default" : "pointer" }}
          >
            <Checkbox
              size="small"
              checked={selectedSheets.includes(sheetName)}
              onChange={(_e, checked) => onSheetChange(sheetName, checked)}
              disabled={disabled}
              inputProps={{ "aria-label": `Include sheet ${sheetName} from ${filename}` }}
            />
            <Typography variant="body2">{sheetName}</Typography>
          </Box>
        ))}
      </Box>
      {noneSelected && (
        <Typography variant="caption" color="error" sx={{ display: "block", mt: 0.5 }}>
          Select at least one sheet
        </Typography>
      )}
    </Box>
  );
};
